export default __webpack_public_path__ + "static/media/our2.105bfc8a.png";